import React, { useEffect, useRef, useState } from "react";
import config from '../../config';
import { headers } from "../../token";
import axios from "axios";
import { Link } from "react-router-dom";
import vAdminformat from '../../adminFormat';
import Swal from "sweetalert2";

import STLViewer from "../Canvas/STLViewer";
import ColorBox from "../ColorBox";
import QRCode from "react-qr-code";
import { useReactToPrint } from 'react-to-print';
import validateError from "../../ValidateError";
import SimpleSTLViewerToImage from "../Canvas/SimpleStlViewsImage";

const server_backend = config.API_URL;
const server_frontend = config.FrondEndURL;

const QRUpdateJobs = ({ JobID, CloseViewJob, onRenderComplete, getJobs, getCurrentJob }) => {

    const [Job, setJob] = useState({
        jobs: []

    });
    const [trackingView, setTrackingView] = useState([]);
    const [isComment, setIsComment] = useState(false);
    const [isModifiyComment, setIsModifyComment] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);
    const [loading, setLoading] = useState(false);
    const [fileURL, setFileURL] = useState(null);
    const [statusJob, setStatusJob] = useState([]);
    const [showPrintableDiv, setShowPrintableDiv] = useState(false);
    const [currentDateTime, setCurrentDateTime] = useState('');
    const [currentComment, setCurrentComment] = useState("");
    const [currentPart, setCurrentPart] = useState([]);
    const [currentStatus, setCurrentStatus] = useState(null);

    useEffect(() => {
        const getCurrentJob = async () => {
            setLoading(true)
            try {
                const response = await axios.get(`${server_backend}/jobs/select?id=${JobID}`, headers);
                console.log({ Here: response.data })
                if (response.data.RES_CODE === "00") {

                    const data = (response.data.RES_RESULT);
                    setCurrentDateTime(data.date_estimated);
                    setCurrentComment(data.comment);
                    setCurrentPart(data.parts)
                    setCurrentStatus(data.est_ID);
                    setFileURL(`${server_backend}/${data.files_path_file}`);
                    setJob(data);
                }
            } catch (error) {
                console.log(error)
            } finally {
                setLoading(false)
                onRenderComplete && onRenderComplete()
            }
        }
        getCurrentJob();
    }, []);

    useEffect(() => {
        const getStatusJob = async () => {
            try {
                const response = await axios.get(`${server_backend}/system/transactions/status/Job`, headers);
                console.log(response.data);
                if (response.data.RES_CODE === "00") {
                    setStatusJob(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log(error);
            }
        }
        getStatusJob();
    }, []);

    useEffect(() => {
        const getTrackingData = async () => {
            try {
                const response = await axios.get(`${server_backend}/Jobs/tracking/list?id=${JobID}`, headers);
                if (response.data.RES_CODE === "00") {

                    const data = (response.data.RES_RESULT);
                    setTrackingView(data)
                }
            } catch (error) {
                console.log(error)
            }
        }
        getTrackingData();
    }, []);

    /*    const getCurrentJob = async () => {
           try {
               const response = await axios.get(`${server_backend}/jobs/select?id=${JobID}`, headers);
               //console.log(response.data)
               if (response.data.RES_CODE === "00") {
                   //console.log(response.data.RES_RESULT);
                   const data = (response.data.RES_RESULT);
                   setCurrentDateTime(data.date_estimated);
setCurrentComment(data.comment);
                   setFileURL(`${server_backend}/${data.files_path_file}`)
                   setJob(data)
               }
           } catch (error) {
               console.log(error)
           } finally {
               onRenderComplete && onRenderComplete()
           }
       } */

    const getTrackingData = async () => {
        try {
            const response = await axios.get(`${server_backend}/Jobs/tracking/list?id=${JobID}`, headers);
            if (response.data.RES_CODE === "00") {
                //console.log(response.data.RES_RESULT)
                const data = (response.data.RES_RESULT);
                setTrackingView(data)
            }
        } catch (error) {
            console.log(error)
        }
    }



    const CloseAddCommentModal = () => {
        setIsComment(false)
    }

    const showModifyCommentModal = () => {
        setIsModifyComment(true)
    }

    const CloseModifyCommentModal = () => {
        setIsModifyComment(false)
    }

    const ShowModalUpdate = () => {
        setIsUpdating(true);
    }

    const CloseModalUpdate = () => {
        setIsUpdating(false);
    }

    //Initializes the current step from the backend
    const currentStep = statusJob.find((status) => status.est_ID === Job.est_ID)?.est_ID || 0;

    //Status to store the selected steps
    const [selectedSteps, setSelectedSteps] = useState([]);

    //Initial load of the selected steps based on the Currentstep
    useEffect(() => {
        if (currentStep > 0) {
            const initialSteps = statusJob
                .filter((step) => step.est_ID <= currentStep)
                .map((step) => step.est_ID);
            setSelectedSteps(initialSteps);
        }
    }, [currentStep, statusJob]);

    //Function to handle a state
    const handleStepClick = (clickedStepId) => {
        const updatedSteps = statusJob
            .filter((step) => step.est_ID <= clickedStepId) //filters the steps smaller than or equal to the selected
            .map((step) => step.est_ID); //Obtain only the IDS of the steps

        setSelectedSteps(updatedSteps); //Update the state with the selected steps
    };

    const statusDescriptions = {
        18: "In the process of printing the production folder.",
        19: "Preparing the model for building.",
        20: "The model is being invested for molding.",
        21: "Casting process is in progress.",
        22: "Production is complete and ready for review.",
    };

    const componentRef = useRef();


    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: "Material Information",
        onAfterPrint: () => setShowPrintableDiv(false),

    });

    const handleClick = () => {

        setShowPrintableDiv(true);
        setTimeout(() => {
            handlePrint();
        }, 2000);

    };

    /*const changeStatus = async (estID) => {

        Swal.fire({
            icon: 'warning',
            title: 'Alert',
            text: "Are you sure you want to mark this status?",
            showCancelButton: true,
            confirmButtonText: 'Accept',
            cancelButtonText: "Cancel"
        }).then(async (result) => {
            if (result.isConfirmed) {
                setLoading(true);
                try {
const response = await axios.post(`${server_backend}/jobs/point`, {
                        id: JobID,
                        est_id: estID
                    }, headers);
                    if (response.data.RES_CODE === "00") {
                        Swal.fire({
                            icon: 'success',
                            title: 'Created Successfully',
                            showConfirmButton: false,
                            timer: 2000
});

                        getCurrentJob()
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'an unexpected error has occurred',
                            showConfirmButton: false,
                            timer: 2000
                        });
                    }
                } catch (error) {
                    const message = validateError(error);
Swal.fire({
                        icon: 'error',
                        title: message,
                        showConfirmButton: false,
                        timer: 2000
                    });
                } finally {
                    setLoading(false);
                }
            }
        })

    }; */

    const [imageURL, setImageURL] = useState(null);

    useEffect(() => {
        const loadImage = async () => {
            try {
                const image = await SimpleSTLViewerToImage(fileURL);

                setImageURL(image);
            } catch (error) {
                console.error('Error:', error);
            }
        };

        if (fileURL) {
            loadImage();
        }
    }, [fileURL]);

    useEffect(() => {
        const now = new Date();
        const formattedDateTime = now.toISOString().slice(0, 16); //Get current date and time in YYYY-MM-DDTHH:MM format
        setCurrentDateTime(formattedDateTime);
    }, []);

    const handleUpdate = async () => {

        Swal.fire({
            icon: 'warning',
            title: 'Alert',
            text: "Are you sure you want to save the changes?",
            showCancelButton: true,
            confirmButtonText: 'Accept',
            cancelButtonText: "Cancel"
        }).then(async (result) => {
            if (result.isConfirmed) {

                try {
                    const response = await axios.post(`${server_backend}/jobs/point`, {
                        id: JobID,
                        est_id: currentStatus,
                        parts: currentPart,
                        date_estimated: currentDateTime,
                        job_comments: currentComment
                    }, headers);
                    //console.log(response.data);
                    if (response.data.RES_CODE === "00") {
                        Swal.fire({
                            icon: 'success',
                            title: 'Save Successfully',
                            showConfirmButton: false,
                            timer: 1000
                        });
                        getCurrentJob && getCurrentJob()
                        CloseViewJob()
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'An error occurred, please try again.',
                            showConfirmButton: false,
                            timer: 2000
                        });
                    }
                } catch (error) {
                    const message = validateError(error);

                    Swal.fire({
                        icon: 'error',
                        title: message,
                        showConfirmButton: false,
                        timer: 2000
                    });
                } finally {
                    setLoading(false);

                }
            }
        }
        )

    };
    return (

        <div className="container-fluid">
            {/*start page title */}
            <div>

                <div className="row justify-content-center">
                    <div className="col-12 card">
                        <div className="card-header">
                            <div className="hstack gap-2 justify-content-end d-print-none mt-4">
                                <div className="text-center flex-grow-1">
                                    <span className="fw-bold">Order Ref: <Link>{Job.ord_ID}</Link></span>
                                </div>
                                <Link className='btn btn-danger' style={{ marginRight: "5px" }} onClick={CloseViewJob}>Discard Change</Link>
                                <button type="submit" className="btn btn-primary" onClick={handleUpdate}><i className="ri-save-line align-bottom me-1"></i> Save</button>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-8 col-md-12">
                                <div className="row">
                                    <div className="col-lg-6 col-md-12">
                                        <div className="card">
                                            <div className="card-header">
                                                <div className="d-sm-flex align-items-center">
                                                    <h5 className="card-title flex-grow-1 mb-0">{Job.file_name}</h5>
                                                </div>
                                            </div>

                                            <div className="card-body" style={{ height: "100%", width: "100%" }}>
                                                <div className="row">
                                                    {/*STL Viewer */}
                                                    <div className="col-12 mb-4" style={{ height: "224px" }}>
                                                        <STLViewer url={fileURL} currentColor={Job.materials_color} />
                                                    </div>

                                                    {/*QR Code Section */}
                                                    <div className="col-6 d-flex flex-column align-items-center mb-4">
                                                        {Job?.barcode && (
                                                            <>
                                                                <QRCode
                                                                    size={200}
                                                                    style={{ height: "15vh", width: "15vh" }}
                                                                    value={Job.barcode}
                                                                    viewBox="0 0 256 256"
                                                                />
                                                                <h6 className="mt-3">Single Back to Print Folder Only</h6>
                                                            </>
                                                        )}
                                                    </div>

                                                    <div className="col-6 d-flex flex-column align-items-center mb-4">
                                                        {Job?.barcode && (
                                                            <>
                                                                <QRCode
                                                                    size={200}
                                                                    style={{ height: "15vh", width: "15vh" }}
                                                                    value={Job.barcode}
                                                                    viewBox="0 0 256 256"
                                                                />
                                                                <h6 className="mt-3">Quick Scan Group</h6>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                    </div>

                                    <div className="col-lg-6 col-md-12">
                                        <div className="card">
                                            <div className="card-header">
                                                <div className="d-sm-flex align-items-center">
                                                    <h5 className="card-title flex-grow-1 mb-0">Information</h5>
                                                </div>
                                            </div>
                                            <div className="mt-3">
                                                <div className="table-responsive">
                                                    <table className="table table-bordered table-sm" style={{ lineHeight: '1.9', padding: '0.4rem' }}>
                                                        <tbody>
                                                            <tr>
                                                                <td className="font-weight-bold"><h6>Volume:</h6></td>
                                                                <td className="text-end">{Job.volume}</td>
                                                            </tr>
                                                            <tr>
                                                                <td className="font-weight-bold"><h6>Area:</h6></td>
                                                                <td className="text-end">{Job.area}</td>
                                                            </tr>
                                                            <tr>
                                                                <td className="font-weight-bold"><h6>Weight:</h6></td>
                                                                <td className="text-end">{Job.weight}</td>
                                                            </tr>
                                                            <tr>
                                                                <td className="font-weight-bold"><h6>Dimensions:</h6></td>
                                                                <td className="text-end">{Job.dimensions}</td>
                                                            </tr>
                                                            <tr>
                                                                <td className="font-weight-bold"><h6>Material:</h6></td>
                                                                <td className="text-end">
                                                                    <ColorBox color={Job.materials_color} />
                                                                    <span className="ms-2" style={{ marginBottom: "7px" }}>{Job.materials_name}</span>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            <div className="d-sm-flex align-items-center">
                                                <h5 className="card-title flex-grow-1 mb-0">Job Information</h5>
                                            </div>
                                            <div className="mt-3">
                                                <div className="table-responsive">
                                                    <table className="table table-bordered table-sm" style={{ lineHeight: '1.9', padding: '0.4rem' }}>
                                                        <tbody>
                                                            <tr>
                                                                <td className="font-weight-bold"><h6>Name:</h6></td>
                                                                <td className="text-end">{"Customer Name"}</td>
                                                            </tr>
                                                            <tr>
                                                                <td className="font-weight-bold"><h6>Job Number:</h6></td>
                                                                <td className="text-end">{Job.job_number}</td>
                                                            </tr>
                                                            <tr>
                                                                <td className="font-weight-bold"><h6>Description:</h6></td>
                                                                <td className="text-end">{"Wed band"}</td>
                                                            </tr>
                                                            <tr>
                                                                <td className="font-weight-bold"><h6>Alloy:</h6></td>
                                                                <td className="text-end">
                                                                    {Job.materials_name}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="font-weight-bold"><h6>Date:</h6></td>
                                                                <td className="text-end">{vAdminformat.FormatDate(Job.date_created)}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="col-12 mb-3">
                                        <div className="row mt-3">
                                            {/*Estimated Completion Date Field */}
                                            <div className="col-6 d-flex flex-column">
                                                <label htmlFor="estimatedCompletionInput" className="form-label">Estimated Completion Date</label>
                                                <input
                                                    type="datetime-local"
                                                    className="form-control text-center"
                                                    id="estimatedCompletionInput"
                                                    value={currentDateTime} //Set default value to current date and time
                                                    onChange={(e) => setCurrentDateTime(e.target.value)} //Allow user to change the date and time
                                                />
                                            </div>

                                            {/*Parts Field */}
                                            <div className="col-6 d-flex flex-column">
                                                <label htmlFor="partsInput" className="form-label">Parts</label>
                                                <input
                                                    type="number"
                                                    className="form-control text-center"
                                                    id="partsInput"
                                                    value={parseInt(currentPart)}
                                                    onChange={(e) => setCurrentPart(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12">
                                        <textarea
                                            className="form-control"
                                            placeholder="Add instructions"
                                            style={{ height: "13vh", width: "100%", resize: "none" }}
                                            value={currentComment}
                                            onChange={(e) => setCurrentComment(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-12 mt-3 mt-lg-0">
                                <div className="card">
                                    <div className="card-header">
                                        <div className="d-sm-flex align-items-center">
                                            <h5 className="card-title flex-grow-1 mb-0">Order Status</h5>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="profile-timeline">
                                            <div className="accordion accordion-flush">
                                                {statusJob.map((step) => (
                                                    <div className="accordion-item border-0" key={step.est_ID}>
                                                        <div className="accordion-header" id={`heading${step.est_ID}`}>
                                                            <div
                                                                className={`accordion-button p-2 shadow-none ${selectedSteps.includes(step.est_ID) ? "bg-highlighted" : ""
                                                                    }`}
                                                            >
                                                                <div className="d-flex align-items-center w-100">
                                                                    <div className="flex-shrink-0 avatar-xs th-hover-status">
                                                                        <div
                                                                            className={`avatar-title ${selectedSteps.includes(step.est_ID) ? "bg-secondary" : "bg-light text-secondary"
                                                                                } rounded-circle`}
                                                                            onClick={() => {
                                                                                handleStepClick(step.est_ID);
                                                                                setCurrentStatus(step.est_ID);
                                                                            }
                                                                            }
                                                                        >
                                                                            <i className="ri-check-line"></i>
                                                                        </div>
                                                                    </div>

                                                                    <div className="flex-grow-1 ms-3">
                                                                        <h6 className="fs-15 mb-1 fw-semibold">{step.name}</h6>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/*Show description for each state */}
                                                        <div
                                                            id={`collapse${step.est_ID}`}
                                                            className="accordion-collapse collapse show"
                                                            aria-labelledby={`heading${step.est_ID}`}
                                                        >
                                                            <div className="accordion-body ms-2 ps-5 pt-0 p-0">
                                                                <p className="text-muted">{vAdminformat.FormatDate(Job.date_created)}</p>
                                                                <p className="text-muted">{statusDescriptions[step.est_ID]}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*end card*/}
                        <div className="hstack gap-2 justify-content-end d-print-none mt-4 p-2">
                            <Link className='btn btn-danger' style={{ marginRight: "5px" }} onClick={CloseViewJob}>Discard Change</Link>
                            <button type="submit" className="btn btn-primary" onClick={handleUpdate}><i className="ri-save-line align-bottom me-1"></i> Save</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    )
}


export default QRUpdateJobs;